const endpoint = process.env.REACT_APP_CRM_API_URL;
const apiKey = process.env.REACT_APP_CRM_API_KEY;

import "isomorphic-fetch";


export async function crmSubscribe(email, name, website, phone, subscriptionId) {
    return await fetch(`${endpoint}/subscribe-contact`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiKey
        },
        body: JSON.stringify({
            email,
            website,
            name,
            phone,
            subscriptionId
        })
    });
}

export async function crmCreateContact(email, name, message, website, phone) {
    return await fetch(`${endpoint}/contact`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiKey
        },
        body: JSON.stringify({
            email,
            website,
            name,
            phone,
            message
        })
    });
}
